import {languageFromLocale} from '@shopify/i18n';

interface LanguageMap {
  [language: string]: string;
}

export const DEFAULT_LANGUAGE = 'en';

export const LocalizedAdminLanguages: LanguageMap = {
  cs: 'Čeština',
  da: 'Dansk',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fi: 'Suomi',
  fr: 'Français',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  nl: 'Nederlands',
  nb: 'Norsk (bokmål)',
  pl: 'Polski',
  'pt-BR': 'Português (Brasil)',
  'pt-PT': 'Português (Portugal)',
  sv: 'Svenska',
  tr: 'Türkçe',
  th: 'ภาษาไทย',
  vi: 'Tiếng Việt',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
};

export function helpCenterBaseUrl(locale: string) {
  const language = supportedLanguageFromLocale(locale);
  return `https://help.shopify.com/${language}`;
}

export function supportedLanguageFromLocale(locale: string) {
  if (locale in LocalizedAdminLanguages) {
    return locale;
  }
  const language = languageFromLocale(locale);
  if (language in LocalizedAdminLanguages) {
    return language;
  }
  return DEFAULT_LANGUAGE;
}
